var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHat = function SvgHat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 44,
    height: 40,
    viewBox: "0 0 3.2 2.91",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".str0{stroke:#000;stroke-width:.37;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256}.fil0{fill:none}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2315638532688"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M1.33.49c.85-.16 1.42.54 1.11 1.29-.14.37-.43.79-.72.93-.31.15-1.03-.63-1.09-1.19C.57.97.78.6 1.33.49z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M.18 1.17c.55.14 1.27.06 1.85.11.4.03.61.01.97-.02h.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "str0",
    d: "m.62 1.24 1.97.05c-.01-.11.03-.95-.07-.97C2 .18 1.53.17.98.2L.6.21s.02.46 0 .6c-.01.03 0 .34 0 .39-.01.01.02.04.02.04z",
    fill: "#000"
  })))));
};

export default SvgHat;